import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Pencil, Trash2 } from 'lucide-react';
import { CardMenu } from '../../ui';
import CreateWorkflowModal from '../CreateWorkflowModal';
import DeleteWorkflowModal from '../DeleteWorkflowModal';

const ACCENT_COLORS = ['#fedd58', '#8B5CF6', '#10B981', '#F59E0B', '#EC4899', '#3B82F6', '#EF4444', '#14B8A6'];

const WorkflowCard = ({ workflowCardsData }) => {
  const navigate = useNavigate();
  const [editCard, setEditCard] = useState(null);
  const [deleteCard, setDeleteCard] = useState(null);

  return (
    <>
      {workflowCardsData?.map((card, index) => {
        const accent = ACCENT_COLORS[index % ACCENT_COLORS.length];
        return (
          <div
            key={card.workflow_id || card.id || card.name}
            className="p-5 rounded-lg bg-shell-card border border-shell-card-border hover:border-white/30 hover:bg-white/[0.04] transition-all duration-200">
            <div className="flex items-start justify-between mb-4">
              <button
                type="button"
                onClick={() => navigate(`/workflows/${card.workflow_id}`)}
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${accent}1A` }}>
                <span className="text-sm font-bold" style={{ color: accent }}>
                  {card?.name?.[0]?.toUpperCase() || '?'}
                </span>
              </button>
              <CardMenu
                items={[
                  { label: 'View Workflow', icon: Eye, onClick: () => navigate(`/workflows/${card.workflow_id}`) },
                  { label: 'Edit Details', icon: Pencil, onClick: () => setEditCard(card) },
                  { label: 'Delete Workflow', icon: Trash2, onClick: () => setDeleteCard(card), danger: true },
                ]}
              />
            </div>
            <button
              type="button"
              onClick={() => navigate(`/workflows/${card.workflow_id}`)}
              className="block w-full text-left">
              <h3 className="text-base font-semibold text-white mb-2 truncate capitalize">{card?.name}</h3>
              <p className="text-sm text-muted leading-relaxed line-clamp-2">{card?.description}</p>
            </button>
          </div>
        );
      })}

      {editCard && <CreateWorkflowModal onClose={() => setEditCard(null)} isEdit={editCard} />}
      {deleteCard && <DeleteWorkflowModal onClose={() => setDeleteCard(null)} isEdit={deleteCard} />}
    </>
  );
};

export default WorkflowCard;
